/**
 * Builds a react-dropzone `accept` map (mime type -> extensions) from a list of file extensions.
 * Special-cases `zip` and `xbrl`, which don't map to a single well-known mime type.
 */
export const formatAccept = (extensions: string[]) => {
  const accept: Record<string, string[]> = {};
  extensions.forEach((ext) => {
    if (ext === 'zip' || ext === '.zip') {
      accept['application/zip'] = ['.zip'];
      accept['application/x-zip-compressed'] = ['.zip'];
      accept['multipart/x-zip'] = ['.zip'];
      accept['application/x-compressed'] = ['.zip'];
    } else if (ext === 'xbrl' || ext === '.xbrl') {
      accept['application/xbrl'] = ['.xbrl'];
    } else {
      const cleanExt = ext.startsWith('.') ? ext : `.${ext}`;
      accept[`application/${ext.replace(/^\./, '')}`] = [cleanExt];
    }
  });
  return accept;
};
